// XXX this file should be kept in sync with its Go counterpart
// native/pkg/ws/msg.go

// actions
export const READY = "ready";
export const OFFER = "offer";
export const ANSWER = "answer";
export const WITHDRAW = "withdraw";
export const DECLINE = "decline";
export const SYNC = "sync";
export const CLOSE = "close";
export const HOST_UPDATE = "host_update";
export const HOST_REFRESH = "host_refresh";
export const ADMIN_MACHINE_REFRESH = "admin_machine_refresh";
export const ADMIN_CONNECTION_REFRESH = "admin_connection_refresh";
export const INVITE_REFRESH = "invite_refresh";
export const MACHINE_ACCESS_INVITE_REFRESH = "machine_access_invite_refresh";

// error codes
export const ErrorCodeHostUpdateFailed = "host_update_failed";

/**
 * @typedef {object} Candidate
 * @property {string} addr
 * @property {number} port
 * @property {boolean} short_ttl
 */

/** @typedef {object} ReadyData */

/**
 * @typedef {object} OfferData
 * @property {string} ufrag
 * @property {string} pwd
 * @property {string} cert_hash
 * @property {Candidate[]} candidates
 */

/**
 * @typedef {object} AnswerData
 * @property {string} ufrag
 * @property {string} pwd
 * @property {string} cert_hash
 * @property {Candidate[]} candidates
 */

/** @typedef {object} WithdrawData */

/** @typedef {object} DeclineData */

/** @typedef {object} SyncData */

/**
 * @typedef {object} CloseData
 * @property {string} code
 * @property {string} message
 */

/** @typedef {object} HostRefreshData */

/** @typedef {object} AdminMachineRefreshData */

/** @typedef {object} AdminConnectionRefreshData */

/** @typedef {object} InviteRefreshData */

/** @typedef {object} MachineAccessInviteRefreshData */

/**
 * @typedef {object} HostUpdateData
 * @property {string} name
 * @property {string} version
 * @property {string} os
 * @property {string} platform
 * @property {string} source
 * @property {string} channel
 */
